import { round, Session } from "utils";
import Client from "./_client";

export const getCompaniesWithDetails = async (filters) => {
  let url = "/codeChallenge/filter/company?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get comapanies details. Please try again."
    );
  }
  return result?.data;
}

export const getSubTopicsWithDetails = async (filters = {}) => {
  let url = "/codeChallenge/filter/subTopic";

  const queryParams = Object.keys(filters)
    .filter((key) => filters[key] !== undefined)
    .map((key) => `${key}=${filters[key]}`)
    .join("&");

  if (queryParams) {
    url += `?${queryParams}`;
  }

  const result = await new Client({ path: url }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get subTopic details. Please try again."
    );
  }

  return result?.data;
};

export const getCodeChallenges = async (filters) => {
  let url = "/codeChallenge?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get challenges. Please try again."
    );
  }
  return result?.data;
}

export const getChallengesByTags = async (filters) => {
  let url = "/codeChallenge/filters?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get challenges. Please try again."
    );
  }
  return result?.data;
}

export const starredCodeChallengeById = async (challengeId) => {
  
  let result = await new Client({
    path: `/codeChallenge/${challengeId}/starred`,
  }).put();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to bookmark question. Please try again."
    );
  }
  return result.data;
}

export const getCodeChallengeById = async (id) => {
  let url = `/codeChallenge/${id}`;
  
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get challenge. Please try again."
    );
  }
  return result?.data;
}

export const getCodeLanguages = async () => {
  let url = "/codeChallenge/languages";

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get languages. Please try again."
    );
  }
  return result?.data;
}

export const runCode = async (codeData) => {
  let url = "/codeChallenge/run"

  const result = await new Client({
      path: url,
      payload: {
        languageId: codeData.languageId,
        sourceCode: codeData.sourceCode,
        stdin: codeData.stdin,
        base64Encoded: codeData.base64Encoded,
        codeChallengeAttemptId : codeData.codeChallengeAttemptId
      }
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to run code. Please try again."
    );
  } else {
    return result.data;
  }
};

export const getMyPreparationList = async () => {
  let url = "/userCodeDetail/preparationList";
  
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get preparation list. Please try again."
    );
  }
  
  return result?.data;
}

export const codeSubmission = async (data) => {
  let url = "/codeChallenge/submission"

  const result = await new Client({
      path: url,
      payload: data
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to submit code. Please try again."
    );
  } else {
    return result.data;
  }
};

export const generateFollowup = async (id, data) => {
  let url = `/codeChallenge/${id}/generate-followUp`

  const result = await new Client({
      path: url,
      payload: data
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to generate follow Up. Please try again."
    );
  } else {
    return result.data;
  }
};

export const skipCodeExplanation = async (data) => {
  let url = `/analyse/code-explanation/skip`

  const result = await new Client({
      path: url,
      payload: data
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to skip. Please try again."
    );
  } else {
    return result.data;
  }
};

export const finishChallenge = async (id, data) => {
  let url = `/codeChallengeAttempt/${id}/finish`

  const result = await new Client({
      path: url,
      payload: data
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to finish challenge. Please try again."
    );
  } else {
    return result.data;
  }
};

export const createPersonalizedChallenge = async (data) => {
  let url = "userCodeDetail/personalized";

  const result = await new Client({
      path: url,
      payload: data
    }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message ||
      "Uh Oh! Unable to create interview. Please try again."
    );
  } else {
    return result.data;
  }
};

export const generateHint = async (
  {id, data, audioBlob}, onEvent
) => {                                                                        
  const apiUrl = process.env.REACT_APP_API_URL;                                                                          

  const formData = new FormData();    
  const httpRequest = new XMLHttpRequest();                    

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  
  formData.append("audio", audioBlob);

  httpRequest.upload.addEventListener('progress', (e) => {
      const progress = round((e.loaded / e.total) * 100);
      onEvent('progress', progress);
    });
  
    httpRequest.onload = (e) => {
      const response = JSON.parse(e?.target?.response || null);
  
      if (e?.target?.status !== 200) {
        onEvent('error', response?.data);
      } else if (response?.data?.isError) {
        onEvent('analysed', response?.data);
      } else {
        onEvent('analysed', response?.data);
      }
    };
    httpRequest.onabort = (e) => {
      onEvent('error', e);
    };
    httpRequest.onerror = (e) => {
      onEvent('error', e);
    };

  httpRequest.open('POST', `${apiUrl}/codeChallenge/${id}/generate-hint`, true);
  httpRequest.setRequestHeader('userId', Session.userId);
  httpRequest.setRequestHeader('languify-application', 'interview');
  httpRequest.setRequestHeader('languify-access-token', Session.accessToken);
  httpRequest.setRequestHeader(
    "languify-session-id", localStorage?.getItem("languifySessionId")
  );
  httpRequest.send(formData);
};

export const getMyMockList= async (batch) => {

  let url = `/userCodeDetail/mock/user?batch=${batch}`;
  
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get contest list. Please try again."
    );
  }
  
  return result?.data;
}

export const getMockById = async (id) => {

  let url = `/userCodeDetail/${id}`;
  
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get mock. Please try again."
    );
  }
  
  return result?.data;
}
